import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

// Import styles
import { media, flex } from 'components/styles';

// Import helpers
import { minMaxHeight } from 'components/views/vod/components/sliders/Carousel/helpers';
const LINE_HEIGHT = 29;

export const TitleContainer = styled.div`
	width: 41vw;
	height: 12.5vh;
	height: ${({ isSeries }) => (isSeries ? 9 : 12.5)}vh;
	${({ isSeries }) => (isSeries ? minMaxHeight(9) : minMaxHeight(12.5))};
	margin-bottom: 2.3vh;
	position: relative;
	display: flex;
	align-items: center;
`;

export const Image = styled.img`
	object-fit: contain;
	object-position: center left;
	width: 100%;
	height: 100%;
`;

export const TitleLink = styled(Link)`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	&:hover {
		color: initial;
	}
`;

export const TitleText = styled.div`
	color: ${({
		theme: {
			vod: { font }
		}
	}) => font.whiteGrayLight};
	font-size: 3rem;
`;

export const InfoContent = styled.div`
	position: absolute;
	z-index: 999;
	min-height: 100%;
	top: calc(100vw * (9 / 16));
	padding-top: 1rem;

	${media.min.xmin(css`
		position: relative;
		top: unset;
	`)}
`;

export const Description = styled.div`
	height: ${LINE_HEIGHT * 3}px;
	line-height: ${LINE_HEIGHT}px;
	text-align: justify;
	margin-bottom: 2rem;
	font-size: 1.5rem;
	padding-right: 1rem;

	${media.min.min(css`
		text-align: left;
		margin-bottom: 3rem;
		font-size: 1.76rem;
	`)}
	overflow-y: auto;
	touch-action: pan-y;
	color: ${({
		theme: {
			vod: { font }
		}
	}) => font.whiteGrayLight};
	transition: height ease 300ms;

	&::-webkit-scrollbar {
		width: 7px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.25);
		border-radius: 5px;
	}

	&::-webkit-scrollbar-track {
		border-radius: 5px;
		background-color: rgba(255, 255, 255, 0.15);
	}
`;

export const ButtonsWrapper = styled.div`
	max-width: 80vw;
	${flex({ fd: 'column' })}
	margin: 1rem auto;
	font-size: 1.4rem;
	> *:not(:last-child) {
		margin-bottom: 1.5rem;
	}

	${media.min.min(css`
		flex-direction: row;
		justify-content: flex-start;
		min-height: 7.3rem;
		font-size: 1.6rem;
		margin: 0 0 ${({ isSeries }) => (isSeries ? 1.6 : 2.5)}vh -7px;

		> * {
			margin: 0 7px 14px;
			padding: 0;
		}
	`)}
`;
